const toggler = document.getElementById('login-box__regist__toggler');
if(toggler){
    const input = toggler.previousElementSibling;
    toggler.addEventListener('click', () => {
        const currretType = input.getAttribute('type');
        if(currretType === 'password'){
            input.setAttribute('type', 'text');
            toggler.classList.add('login-box__regist__toggler--open');
        }else if(currretType === 'text'){
            input.setAttribute('type', 'password');
            toggler.classList.remove('login-box__regist__toggler--open');
        }
    });
}

const passwordConfirmBox = document.getElementById('login-box__regist__password');
if(passwordConfirmBox){
    const passwordConfirmBoxTxt = passwordConfirmBox.getElementsByTagName('span')[0];
    const passwordConfirmBoxBtn = passwordConfirmBox.getElementsByTagName('button')[0];
    console.log(passwordConfirmBoxTxt, passwordConfirmBoxBtn);
    const passwordTxt = passwordConfirmBoxTxt.textContent.trim();
    let hideTxt = '';
    for (let index = 0; index < passwordTxt.length; index++) {
        hideTxt += '.';
    }
    console.log(hideTxt);
    passwordConfirmBoxTxt.textContent = hideTxt;
    passwordConfirmBoxBtn.addEventListener('click', () => {
        if(passwordConfirmBoxBtn.classList.contains('login-box__regist__password__btn--open')){
            passwordConfirmBoxBtn.classList.remove('login-box__regist__password__btn--open');
            passwordConfirmBoxTxt.textContent = hideTxt;
        }else{
            passwordConfirmBoxBtn.classList.add('login-box__regist__password__btn--open');
            passwordConfirmBoxTxt.textContent = passwordTxt;
        }
    });
}
